import * as Sentry from "@sentry/react";

export const logErrorsSentry = (error?: any, errorType?: string, errorLevel?: string, detail?: string) => {
    if(error){
        Sentry.captureException(error, {level: "error", extra: {errorType: errorType}})
    }else if (detail){
        Sentry.captureMessage(errorType?? "", {level:"info", extra: {detail: detail, errorLevel: errorLevel}})
    }
}